import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options, references } from '@apexdesigner/schema-tools';

export const userTaskHistory = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    eventType: options([
      { value: 'Created', name: 'Created' },
      { value: 'Claimed', name: 'Claimed' },
      { value: 'Unclaimed', name: 'Unclaimed' },
      { value: 'Reassigned', name: 'Reassigned' },
      { value: 'Completed', name: 'Completed' },
      { value: 'Data Updated', name: 'Data Updated' },
    ]).describe('What happened to the task'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Additional details about what changed'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this event occurred'),

    userTaskId: z.uuid().hidden().describe('Foreign key to UserTask'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    userTask: belongsTo('UserTask'),

    tenant: references('Tenant'),
  })
  .describe('Records each action taken on a user task')
  .as('UserTaskHistory');

export { userTaskHistory as userTaskHistorySchema };
